import { Box, CircularProgress, Stack, Typography } from '@mui/material'
import React from 'react'
import { t } from 'i18next'

const Loading = () => {
  return (
    <Stack direction="column" sx={{ alignItems: 'center', gap: 5, justifyContent: 'center', height: '100%' }}>
      <CircularProgress />
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
        <Typography variant="h4" sx={{ color: 'text.highEmphasis' }}>
          {t('components.loading.loading')}
        </Typography>
        <Typography variant="body1">{t('components.loading.viewPreparing')}</Typography>
      </Box>
    </Stack>
  )
}

export default Loading
